var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon() && _vm.icon().iconType === 'fontawesome' )?_c('i',{class:_vm.icon().iconName,style:(_vm.size ? `width: ${_vm.size}px; height: ${_vm.size}px` : '')}):_c('i',{style:(_vm.size ? `width: ${_vm.size}px; height: ${_vm.size}px` : ''),attrs:{"data-feather":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }